import { requestIdleCallback } from './event';
import { getB } from '../helpers/cookie';

/**
 * Method to pass data to Optimize so the event/data shows in the splunk warehouse
 * @param {String} eventName - Name of the event to emit to splunk
 * @param {Object} payload - Data to emit to splunk (Optional)
 */
export function trackEvent(eventName, payload = {}) {
  if (!OptimizeSuite || !OptimizeSuite.TrackingHub) {
    return;
  }

  requestIdleCallback(() => {
    OptimizeSuite.TrackingHub.add(
      eventName,
      Object.assign({}, payload, {
        b: getB(),
        pageId: window.location.pathname,
      })
    );
  });
}
